(function () {
    'use strict';

    angular
        .module('app')
        .controller('SMSViewCtrl', SMSViewCtrl);

    SMSViewCtrl.$inject = [
        '$q',
        '$routeParams',
        '$location',
        '$scope',
        'DialogService',
        'NavigationAidService',
        'WindowTitleService',
        'UnsavedChangesService',
        'SMS',
        'SMSService'];

    /**
     * @ngdoc control
     * @name SMSViewCtrl
     * 
     * @description
     * Controller which is used to view a SMS message.
     */
    function SMSViewCtrl(
        $q,
        $routeParams,
        $location,
        $scope,
        DialogService,
        NavigationAidService,
        WindowTitleService,
        UnsavedChangesService,
        SMS,
        SMSService) {

        /* jshint validthis:true */
        var vm = this;
        vm.viewTitle = 'View SMS';
        vm.errorMessage = null;
        vm.notFound = false;
        vm.loading = true;
        vm.resendInProgress = false;
        vm.sms = {};
        vm.smsContacts = [];
        vm.saveSMS = saveSMS;
        vm.close = close;
        vm.resendSMS = resendSMS;
        vm.forward = forward;
        vm.viewActivities = viewActivities;
        vm.deleteSms = deleteSms;
        Object.defineProperty(vm, 'dirty', {
            get: function () { return UnsavedChangesService.dirty; }
        });

        activate();

        function activate() {
            var loadPromise = {};
            updateViewTitle();

            if (!_.isNil($routeParams.id) && $routeParams.id !== '') {
                loadPromise = loadSMS;
            } else {
                vm.errorMessage = 'The SMS id must be provided.';
                loadPromise = $q.resolve();
            }

            loadPromise()
                .finally(function () {
                    vm.loading = false;
                    updateViewTitle();
                });
        }

        function loadSMS() {
            return SMS.get($routeParams.id)
                .then(getSMSOk, getSMSError);

            function getSMSOk(data) {
                vm.sms = data;

                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.sms.data',
                    saveFunction: saveSMS,
                    unsavedItemName: 'SMS'
                });
            }

            function getSMSError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    vm.errorMessage = 'Error fetching SMS with id ' + $routeParams.id + '.';
                }
            }
        }

        /**
         * Resends the SMS message
         */
        function resendSMS() {
            vm.resendInProgress = true;
            vm.sms.resend()
                .then(resendSMSOk, resendSMSError)
                .finally(function () {
                    vm.resendInProgress = false;
                });

            function resendSMSOk(response) {
                var resentOkPromises = [];
                resentOkPromises.push(DialogService.alert('SMS was resent.'));
                resentOkPromises.push(loadSMS());

                return $q.all(resentOkPromises);
            }

            function resendSMSError(response) {
                DialogService.error('Error resending SMS', response);
            }
        }

        /**
         * Save the SMS
         */
        function saveSMS() {
            return SMSService.saveSMS(vm.sms.data)
                .then(saveSmsOk, saveSmsError);

            function saveSmsOk(updatedSms) {
                vm.sms.data = updatedSms;
                UnsavedChangesService.dirty = false;
            }

            function saveSmsError(response) {
                DialogService.error('Error saving SMS', response);
            }
        }

        /**
         * Forwards the SMS message
         */
        function forward() {
            $location.url('/sms?copySMSId=' + $routeParams.id);
        }

        /**
         * Opens a dialog to view the history linked to the SMS
         */
        function viewActivities() {
            DialogService.show({
                locals: { smsId: vm.sms.data.Id },
                controller: 'SMSActivitiesDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/sms/sms-activities-dialog.tmpl.html'
            });
        }

        /**
         * Delete the SMS
         */
        function deleteSms() {
            return DialogService.confirm('Delete the SMS?', 'Delete SMS confirm')
                .then(deleteConfirmed);

            function deleteConfirmed() {
                SMSService.deleteSMS(vm.sms.data.Id)
                    .then(deleteOk, deleteError);
            }

            function deleteOk() {
                UnsavedChangesService.clearRegistration();
                NavigationAidService.goBack();
            }

            function deleteError(response) {
                DialogService.error('Error deleting SMS', response);
            }
        }

        /**
         * Navigate to the previous page
         */
        function close() {
            NavigationAidService.goBack();
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = 'View SMS';

            if (!_.isNil(vm.sms) && !_.isNil(vm.sms.data) && !_.isNil(vm.sms.data.Message) && vm.sms.data.Message.length) {
                title += ' - ' + vm.sms.data.Message;
                title = title.substr(0, 128); // Don't let it be too long
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }
    }
})();
